import { useState, useEffect } from 'react';
import "./home-gallery.css";

export const images = [
    { src: "/static/images/happy-valley-ct/happy-valley-ct-doncaster-bathroom-1-staging.webp", alt: "Bathroom 1 staging in a Doncaster East home by Interior 4U.", caption: "" },
    { src: "/static/images/happy-valley-ct/happy-valley-ct-doncaster-bathroom-2-tiling.webp", alt: "Ensuite 1 bathroom after tiling in a Doncaster East home by Interior 4U.", caption: "" },
    { src: "/static/images/happy-valley-ct/happy-valley-ct-doncaster-ensuite-tiling.webp", alt: "Ensuite 2 bathroom after tiling in a Doncaster East home by Interior 4U.", caption: "" },
    { src: "/static/images/happy-valley-ct/happy-valley-ct-doncaster-ensuite-staging.webp", alt: "Ensuite 2 staging in a Doncaster East home by Interior 4U.", caption: "" },
    { src: "/static/images/rochdale-dr/rochdale-dr-burwood-east-bathroom-1-feature-tile-interior-4u.webp", alt: "Bathroom feature wall tiles in Burwood East home by Interior 4U.", caption: "" },
]    

const Gallery = () => {

    const [index, setIndex] = useState(0);
    
        const next = () => setIndex((i) => (i + 1) % images.length);
        const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);
    
        useEffect(() => {
            const timer = setInterval(next, 5000);
            return () => clearInterval(timer);
        }, [index]);

    return (
        <div className="gallery">
            <div className="gallery-slider">

                <div className="gallery-image">
                    <img 
                        src={images[index].src} 
                        alt={images[index].alt} 
                        className="bg-blur" 
                        aria-hidden="true" 
                        quality={40} 
                    />
                    <img 
                        src={images[index].src} 
                        alt={images[index].alt} 
                        className="main-img" 
                        quality={70}
                    />
                </div>

                {images[index].caption && (
                    <div className="gallery-caption">
                        {images[index].caption}
                    </div>
                )}

                <button className="nav-button left" onClick={prev}></button>
                <button className="nav-button right" onClick={next}></button>

                <div className="gallery-dots">
                    {images.map((_, i) => (
                        <button
                            key={i}
                            className={`dot ${i === index ? "active" : ""}`}
                            onClick={() => setIndex(i)}
                            aria-label={`Go to slide ${i + 1}`}
                        />
                    ))}
                </div>

            </div>
        </div>
    )
}

export default Gallery;